const SESSION_KEY = "ups_hub_session";

export const saveSession = (session) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

export const getSession = () => {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
};

export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY);
};

export const parseQuoteBlock = (text) => {
  if (!text) return null;
  const m = text.match(/```quote\s*([\s\S]*?)```/);
  if (!m) return null;
  try {
    return JSON.parse(m[1].trim());
  } catch {
    return null;
  }
};

export const stripQuoteBlock = (text) => {
  if (!text) return "";
  return text.replace(/```quote\s*[\s\S]*?```/, "").trim();
};
